import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import LicenseBasicInfoComponent from './license-basic-info.component';

export const LicenseComponent = ({handleFormChange,handleInnerFormChange,domains,tenantsDetails, back }: any) => {
  const tabItems=[
    {
        id:1,
        title:'License Details',
        component:<LicenseBasicInfoComponent
        tenantsDetails={tenantsDetails} 
        domains={domains}
        handleInnerFormChange={handleInnerFormChange}
        handleFormChange={handleFormChange}
        />,
    isVisible:true,
    },
 
  ]
   
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen"> 
      <TabContainer tabItems={tabItems}/>
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
        </div>
       </div>
  )
}
export default LicenseComponent;